export const fiatSymbols: Record<string, string> = {
  AUD: 'AU$',
  BRL: 'R$',
  CAD: 'C$',
  CNY: '¥',
  DKK: 'kr',
  EUR: '€',
  GBP: '£',
  HKD: 'HK$',
  INR: '₹',
  ISK: 'Íkr',
  JPY: '¥',
  KRW: '₩',
  NZD: 'NZ$',
  PLN: 'zł',
  RUB: '₽',
  SEK: 'kr',
  SGD: 'S$',
  THB: '฿',
  TRY: '₺',
  USD: '$'
}

export const explorerCurrencies = ['BTC', 'ETH', 'BCH']

export const walletCurrencies = ['BTC', 'BCH', 'ETH', 'PAX', 'XLM']
